<template lang="pug">
#product-info
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Products.__Sell') }} : {{ editType == 1 ? $t('Products.__AddNewProduct') : $t('Products.__EditProduct') }}
        template(v-slot:actions)
            v-btn.ml-6(rounded, dark color="#b4b9be" @click="$router.go(-1)") {{ $t('ActionOption.__Cancel') }}
            v-btn.ml-6(rounded, color="primary", @click="saveEdit") {{ $t('ActionOption.__Save') }}
    v-container.slim-container
        .alert-text.my-10 {{ $t('Products.__EditNote') }}
        Alert

        v-form(v-model="formValid", ref="productform")
            .product-info
                .field-label 
                    span {{ $t('Products.__Name') }}
                    span.required *
                v-text-field(
                    v-model="product.name",
                    solo,
                    dense,
                    outlined,
                    required,
                    :rules="[rules.required]"
                )
                .field-label 
                    span {{ $t('Products.__Memo') }}
                v-textarea(
                    v-model="product.description",
                    solo,
                    outlined,
                    height="80"
                )
                .field-label 
                    span {{ $t('Products.__Price') }}
                    span.required *
                v-text-field(
                    v-model.number="product.price",
                    solo,
                    dense,
                    outlined,
                    required,
                    :rules="[rules.required]",
                    type="number"
                )
                .field-label 
                    span {{ $t('Products.__Sell') }}
                v-checkbox(
                    v-model="incomeTag",
                    :label="$t('Products.__IsSellItem')"
                    :rules="!expenseTag&&!incomeTag?[rules.required]:[]",
                )
                .field-label(v-if="incomeTag") 
                    span {{ $t('Products.__IncomeAccount') }}
                    span.required *
                    span.float-right 
                        a(@click="addAccount('Income')") {{ $t('Products.__AddNewAccount') }}
                AccountSelector(
                    v-if="incomeTag",
                    :key="nowTime",
                    v-model="product.incomeAccountId",
                    :rules="incomeTag ? [rules.required] : []"
                )
                //- .field-label 
                //-     span {{ $t('Products.__Purchase') }}
                v-checkbox(
                    v-model="expenseTag",
                    :label="$t('Products.__IsBuyingItem')"
                    :rules="!expenseTag&&!incomeTag?[rules.required]:[]",
                )
                .field-label(v-if="expenseTag")
                    span {{ $t('Products.__ExpenseAccount') }}
                    span.required *
                    span.float-right 
                        a(@click="addAccount('OperatingCosts')") {{ $t('Products.__AddNewAccount') }}
                AccountSelector(
                    v-if="expenseTag",
                    :key="nowTime + 1",
                    v-model="product.expenseAccountId",
                    :rules="expenseTag ? [rules.required] : []"
                )
                //- v-select(solo dense outlined :items="expenseAccounts" item-text="name" item-value="name"  placeholder="選擇會計科目" :rules="[rules.required]")
                .field-label 
                    span {{ $t('Products.__SalesTax') }}
                TaxesSelector(v-model="product.taxes")

        EditAccountDialog(
            v-model="addAccountDialog",
            :edited-item="editedAccountItem",
            :edit-type="1",
            :confirm-action="addAccountDone",
            :account-category-groups="accountCategoryGroups"
        )
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import EditAccountDialog from "@/components/accounting/EditAccountDialog"
import * as unsaveNotify from "@/utils/unsaveNotify.js"

export default {
  mixins: [unsaveNotify.mixin],
  props: ["category"],
  components: { EditAccountDialog },
  data() {
    return {
      nowTime: Date.now(),
      formValid: false,
      incomeTag: false,
      expenseTag: false,
      editType: 1,
      rules: textfieldUtils.rules,
      incomeAccounts: [],
      expenseAccounts: [],
      addAccountDialog: false,
      editedAccountItem: {},
      accountGroup: "",
      accountCategoryGroups: [],
      product: {
        id: "",
        name: "",
        description: "",
        price: null,
        taxes: [],
        taxIds: []
      }
    }
  },
  methods: {
    getProduct(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/getProduct", id)
        .then(
          function(response) {
            this.product = response.data
            if (this.product.incomeAccountId) {
              this.incomeTag = true
            }
            if (this.product.expenseAccountId) {
              this.expenseTag = true
            }

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    saveEdit() {
      this.$refs.productform.validate()
      // if (
      //     (this.incomeTag && this.product.incomeAccountId == null) ||
      //     (this.expenseTag && this.product.expenseAccountId == null)
      // ) {
      //     return
      // }
      var accountValid = this.incomeTag || this.expenseTag
      if (this.formValid && accountValid) {
        this.updateAccountsId()
        this.updateTaxIds()
        if (this.editType == 1) {
          this.createProduct()
        } else {
          this.updateProduct()
        }
      }
    },
    createProduct() {
      this.$store.dispatch("global/startLoading")

      this.$store
        .dispatch("products/createProduct", this.product)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Products",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyCreated"),
                  type: "success"
                }
              }
            })
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateAccountsId() {
      if (!this.incomeTag) {
        this.product.incomeAccountId = null
      }

      if (!this.expenseTag) {
        this.product.expenseAccountId = null
      }
    },
    updateProduct() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/updateProduct", this.product)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Products",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyUpdated"),
                  type: "success"
                }
              }
            })
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateTaxIds() {
      this.product.taxIds = []
      for (var tax of this.product.taxes) {
        this.product.taxIds.push(tax.id)
      }
    },
    addAccount(accountGroup) {
      this.addAccountDialog = true
      this.accountGroup = accountGroup
      this.accountCategoryGroups = [accountGroup]
      this.editedAccountItem = {}
    },
    addAccountDone(accountId) {
      this.nowTime = Date.now()
      if (this.accountGroup == "Income") {
        this.product.incomeAccountId = accountId
      } else if (this.accountGroup == "OperatingCosts") {
        this.product.expenseAccountId = accountId
      }
    }
  },
  watch: {
    taxes(val) {}
  },
  mounted() {},
  created() {
    this.$store.dispatch("global/closeAlert")
    if (this.$route.name == "ProductNew") {
      if (this.category == "sell") {
        this.incomeTag = true
      }
      if (this.category == "buy") {
        this.expenseTag = true
      }
      this.editType = 1
    } else {
      this.id = this.$route.params.id
      this.editType = 2
      this.getProduct(this.id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
